import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import axios from "axios";
//@ts-ignore
import { decodeCookie } from "@utils/CookieUtils";
export var initGoogleSignIn = function initGoogleSignIn() {
  window["googleOneTapLogin"] = function (response) {
    axios.get("/rest/sso/googleOneTap?credential=".concat(response["credential"])).then(function (response) {
      var _a;
      var rid = (_a = response.headers["rid"]) !== null && _a !== void 0 ? _a : "";
      if (rid) {
        window.open("".concat(window["_baseURL"], "/ws/loginProvider?rid=").concat(rid), "GoogleOneTap", "status=no,menubar=no,toolbar=no,width=800,height=600,top=100,left=100");
      } else {
        window.location.reload();
      }
    })["catch"](function (err) {
      return console.log(err);
    });
  };
  window["onGoogleLibraryLoad"] = function () {
    google["accounts"].id.initialize({
      "client_id": "150725646086-0doo80vlsenpekc47k882ki3ldp6ol54",
      "callback": window["googleOneTapLogin"],
      "cancel_on_tap_outside": false
    });
    var googleCooldown = decodeCookie("googleOnetapCooldown");
    if (!googleCooldown || googleCooldown && Date.now() - googleCooldown["time"] > 3600000) {
      google["accounts"].id.prompt();
    }
  };
};